import React, {Component} from 'react';
// import { Link } from 'react-router-dom';

// Import Images
import bnrImg1 from "../../images/banner/img1.jpg";
// import trangleOrange from "../../images/shap/trangle-orange.png";
// import squareDotsOrange from "../../images/shap/square-dots-orange.png";
// import lineCircleBlue from "../../images/shap/line-circle-blue.png";
// import waveBlue from "../../images/shap/wave-blue.png";
// import circleDots from "../../images/shap/circle-dots.png";
// import plusBlue from "../../images/shap/circle-dots.png";
import teamMember1 from "../../images/team/member1.jpeg";
import teamMember2 from "../../images/team/member2.jpeg";
import teamMember3 from "../../images/team/member3.jpeg";
import teamMember4 from "../../images/team/member4.jpeg";
import teamMember5 from "../../images/team/member5.PNG";
import teamMember6 from "../../images/team/member6.jpeg";
import teamMember7 from "../../images/team/member7.jpeg";
import teamMember8 from "../../images/team/member8.jpeg";
import teamMember9 from "../../images/team/member9.jpeg";
import teamMember10 from "../../images/team/member10.JPG";
import teamMember11 from "../../images/team/member11.JPG";
import teamMember12 from "../../images/team/member12.jpg";
import teamMember13 from "../../images/team/member13.jpg";
import teamMember14 from "../../images/team/member14.jpg";	
import teamMember15 from "../../images/team/member15.png";

// Team Content
const teamMembers = [
	{
		title: 'Dr. Madiam Figueredo',
		subtitle: 'Dentist',
		thumb: teamMember1,
		desc: 'Dr. Figueredo, with over two decades of experience in cosmetic and restorative dentistry, specializes in transforming smiles with precision and care. Her expertise in dental implants and aesthetic procedures ensures personalized treatment plans that prioritize both function and aesthetics.',
		// socialMedia: [
		// 	{ platform: 'Twitter', link: 'https://twitter.com/' },
		// 	{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
		// 	{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		// ],
	},
	{
		title: 'Dr. Oliver Pinto',
		subtitle: 'Dentist',
		thumb: teamMember2,
		desc: 'Dr. Pinto is dedicated to family dentistry, focusing on comprehensive oral health care with a compassionate approach. He emphasizes preventive dentistry and patient education to maintain optimal dental health across all ages.',
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{
		title: 'Dr. Maria Alexander',
		subtitle: 'Dentist',
		thumb: teamMember3,
		desc: 'Dr. Alexander is a skilled prosthodontist specializing in dental prosthetics and restorative treatments. Her advanced training in creating functional and aesthetic dental restorations allows her to provide effective and tailored care to enhance patients\' smiles and oral health.',
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{ 
		thumb: teamMember4,
		title: "Elvia",		
		subtitle: "Hygienist",
		desc: "Elvia's gentle approach and meticulous cleanings are integral to our preventive care team. She educates patients on oral hygiene practices and ensures thorough dental cleanings for long-term oral health.",
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{ 
		thumb: teamMember5,
		title: "Wilfrido",		
		subtitle: "Hygienist",
		desc: "Wilfrido's commitment to patient comfort and detailed cleanings supports our preventive dental care efforts. His dedication to educating patients on oral health practices contributes to maintaining healthy smiles.",
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{ 
		thumb: teamMember6,
		title: "Raquel",		
		subtitle: "Lead Assistant",
		desc: 'Raquel leads our clinical team with efficiency and warmth, ensuring smooth operations and patient satisfaction throughout their dental visits. Her organizational skills and patient-focused approach contribute to a positive experience for all our patients.',
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{
		title: 'Stephanie',
		subtitle: 'Treatmant Plan Coordinator',
		thumb: teamMember7,
		desc: 'Stephanie brings energy and attention to detail in her role as a dental assistant. She supports the team by ensuring procedures run smoothly and patients feel comfortable throughout their visits.',

		// socialMedia: [
		// 	{ platform: 'Twitter', link: 'https://twitter.com/' },
		// 	{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
		// 	{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		// ],
	},
	{
		title: 'Isis',
		subtitle: 'Assistant',
		thumb: teamMember8,
    	desc: 'Aliet’s friendly demeanor and strong organizational skills make her an invaluable part of the dental team. She assists with patient care and works to maintain an efficient and welcoming environment.',
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{
		title: 'Alba',
		subtitle: 'Assistant',
		thumb: teamMember15,
    	desc: 'Alba is a dedicated dental assistant who ensures that every patient receives personalized care and attention. Her expertise in assisting with various procedures enhances the overall patient experience.',
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{
		title: 'Mailen',
		subtitle: 'Treatmant Plan Coordinator',
		thumb: teamMember10,
		desc: 'Mailen is an excellent team member, ensuring every patient feels supported and informed throughout their dental journey, whether it be while assisting or laying out their treatmant plan.',
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{
		title: 'Maurilio',
		subtitle: 'Accountant',
		thumb: teamMember9,
		desc: 'Maurilio oversees the financial operations of the practice, ensuring accuracy and efficiency in billing and budgeting. His expertise in accounting helps keep the business side running smoothly.',
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{
		title: 'Roily',
		subtitle: 'Assistant',
		thumb: teamMember11,
		desc: 'Roily is an experienced assistant who works closely with patients to provide exceptional care and ensure their comfort during treatments.',
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{ 
		thumb: teamMember12,
		title: "Sochild",		
		subtitle: "Hygienie Coordinator",
		desc: "Sochild ensures every patient receives a thorough and gentle cleaning experience. She focuses on education and prevention, helping patients build strong daily hygiene habits.",
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{ 
		thumb: teamMember13,
		title: "Monica",		
		subtitle: "Scheduling Coordinator",
		desc: "Monica manages our appointment flow with care and efficiency. She works closely with patients to ensure visits are timely, coordinated, and stress-free from start to finish.",
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	},
	{ 
		thumb: teamMember14,
		title: "Yronelli",		
		subtitle: "Receptionist/New Patient Coordinator",
		desc: 'Yronelli greets every guest with warmth and professionalism. She guides new patients through their first visit and ensures a welcoming, smooth introduction to our office.',
		socialMedia: [
			{ platform: 'Twitter', link: 'https://twitter.com/' },
			{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
			{ platform: 'Instagram', link: 'https://www.instagram.com/' },
		],
	}
	// {
	// 	title: 'Dr. Madiam Figueredo',
	// 	subtitle: 'Dentist',
	// 	thumb: teamMember1,
	// 	desc: 'Dr. Figueredo, with over two decades of experience in cosmetic and restorative dentistry, specializes in transforming smiles with precision and care. Her expertise in dental implants and aesthetic procedures ensures personalized treatment plans that prioritize both function and aesthetics.',
	// 	// socialMedia: [
	// 	// 	{ platform: 'Twitter', link: 'https://twitter.com/' },
	// 	// 	{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
	// 	// 	{ platform: 'Instagram', link: 'https://www.instagram.com/' },
	// 	// ],
	// },
	// {
	// 	title: 'Dr. Oliver Pinto',
	// 	subtitle: 'Dentist',
	// 	thumb: teamMember2,
	// 	desc: 'Dr. Pinto is dedicated to family dentistry, focusing on comprehensive oral health care with a compassionate approach. He emphasizes preventive dentistry and patient education to maintain optimal dental health across all ages.',
	// 	socialMedia: [
	// 		{ platform: 'Twitter', link: 'https://twitter.com/' },
	// 		{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
	// 		{ platform: 'Instagram', link: 'https://www.instagram.com/' },
	// 	],
	// },
	// {
	// 	title: 'Dr. Alexander',
	// 	subtitle: 'Dentist',
	// 	thumb: teamMember3,
	// 	desc: 'Dr. Alexander is a skilled periodontist specializing in gum disease treatment and dental implants. Her advanced training in periodontal surgery allows her to provide effective and tailored care to enhance gum health and restore smiles.',
	// 	socialMedia: [
	// 		{ platform: 'Twitter', link: 'https://twitter.com/' },
	// 		{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
	// 		{ platform: 'Instagram', link: 'https://www.instagram.com/' },
	// 	],
	// },
	// { 
	// 	thumb: teamMember4,
	// 	title: "Elvia",		
	// 	subtitle: "Hygienist",
	// 	desc: "Elvia's gentle approach and meticulous cleanings are integral to our preventive care team. She educates patients on oral hygiene practices and ensures thorough dental cleanings for long-term oral health.",
	// 	socialMedia: [
	// 		{ platform: 'Twitter', link: 'https://twitter.com/' },
	// 		{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
	// 		{ platform: 'Instagram', link: 'https://www.instagram.com/' },
	// 	],
	// },
	// { 
	// 	thumb: teamMember5,
	// 	title: "Wilfrido",		
	// 	subtitle: "Hygienist",
	// 	desc: "Wilfrido's commitment to patient comfort and detailed cleanings supports our preventive dental care efforts. His dedication to educating patients on oral health practices contributes to maintaining healthy smiles.",
	// 	socialMedia: [
	// 		{ platform: 'Twitter', link: 'https://twitter.com/' },
	// 		{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
	// 		{ platform: 'Instagram', link: 'https://www.instagram.com/' },
	// 	],
	// },
	// { 
	// 	thumb: teamMember6,
	// 	title: "Raquel",		
	// 	subtitle: "Lead Assistant",
	// 	desc: 'Raquel leads our clinical team with efficiency and warmth, ensuring smooth operations and patient satisfaction throughout their dental visits. Her organizational skills and patient-focused approach contribute to a positive experience for all our patients.',
	// 	socialMedia: [
	// 		{ platform: 'Twitter', link: 'https://twitter.com/' },
	// 		{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
	// 		{ platform: 'Instagram', link: 'https://www.instagram.com/' },
	// 	],
	// },
	// {
	// 	title: 'Dr. Madiam Figueredo',
	// 	subtitle: 'Dentist',
	// 	thumb: teamMember1,
	// 	desc: 'Dr. Figueredo, with over two decades of experience in cosmetic and restorative dentistry, specializes in transforming smiles with precision and care. Her expertise in dental implants and aesthetic procedures ensures personalized treatment plans that prioritize both function and aesthetics.',
	// 	// socialMedia: [
	// 	// 	{ platform: 'Twitter', link: 'https://twitter.com/' },
	// 	// 	{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
	// 	// 	{ platform: 'Instagram', link: 'https://www.instagram.com/' },
	// 	// ],
	// },
	// {
	// 	title: 'Dr. Oliver Pinto',
	// 	subtitle: 'Dentist',
	// 	thumb: teamMember2,
	// 	desc: 'Dr. Pinto is dedicated to family dentistry, focusing on comprehensive oral health care with a compassionate approach. He emphasizes preventive dentistry and patient education to maintain optimal dental health across all ages.',
	// 	socialMedia: [
	// 		{ platform: 'Twitter', link: 'https://twitter.com/' },
	// 		{ platform: 'LinkedIn', link: 'https://www.linkedin.com/' },
	// 		{ platform: 'Instagram', link: 'https://www.instagram.com/' },
	// 	],
	// },
]

class Team extends Component{
	
	render(){
		return (
			<>
				
				<div className="page-content bg-white">
					
					<div className="banner-wraper">
						<div className="page-banner" style={{backgroundImage: "url("+bnrImg1+")"}}>
							<div className="container">
								<div className="page-banner-entry text-center">
									
									<h1>Our Team</h1>
									{/* <nav aria-label="breadcrumb" className="breadcrumb-row">
										<ul className="breadcrumb">
											<li className="breadcrumb-item"><Link to="/"><svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-home"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg> Home</Link></li>
											<li className="breadcrumb-item active" aria-current="page">Our Team</li>
										</ul>
									</nav> */}
									
								</div>
							</div>
							
							{/* <img className="pt-img1 animate-wave" src={waveBlue} alt=""/>
							<img className="pt-img2 animate2" src={circleDots} alt=""/>
							<img className="pt-img3 animate-rotate" src={plusBlue} alt=""/> */}
						</div>
					</div>
					
					<section className="section-area section-sp1 team-wraper">
						<div className="container">
							
							<div className="row">
								{teamMembers.map((teamMember, index) =>(
									<div key={index} className="col-sm-6">
										<div className="team-member mb-30">
											<div className="team-media">
												<img src={teamMember.thumb} alt=""/>
											</div>
											<div className="team-info">
												<div className="team-info-comntent">
													<h4 className="title">{teamMember.title}</h4>
													<span className="text-secondary">{teamMember.subtitle}</span>
												</div>
												<ul className="social-media mt-3">
												{/* {teamMember.socialMedia.map((social, index) => (
													<li key={index}>
														<a rel="noreferrer" target="_blank" href={social.link}>
															<i className={`fab fa-${social.platform.toLowerCase()}`} />
														</a>
													</li>
												))} */}
												<p>{teamMember.desc}</p>
											</ul>
											</div>
											
										</div>
										{/* <div className="page-banner-entry text-center">
										<h2 className="title">Compassionate Care, Eco-Conscious Approach.</h2>
										<p>{teamMember.desc}</p>
										</div> */}
									</div>
								))}
								
							</div>
						</div>
						
						{/* <img className="pt-img1 animate1" src={trangleOrange} alt=""/>
						
						<img className="pt-img2 animate2" src={squareDotsOrange} alt=""/>
						
						<img className="pt-img3 animate-rotate" src={lineCircleBlue} alt=""/>
						
						<img className="pt-img4 animate-wave" src={waveBlue} alt=""/>
						
						<img className="pt-img5 animate-wave" src={plusBlue} alt=""/> */}
						
					</section>
					
				</div>
				
			</>
		);
	}
}

export default Team;